export type BlogLeadMagnet = {
  id: string;
  downloadPath: { tr: string; en: string };
  title: { tr: string; en: string };
  description: { tr: string; en: string };
  bullets: { tr: string[]; en: string[] };
  fileName: { tr: string; en: string };
};

const MAGNETS: Record<string, BlogLeadMagnet> = {
  'saas-cost-worksheet': {
    id: 'saas-cost-worksheet',
    downloadPath: {
      tr: '/downloads/saas-maliyet-hesaplayici-2026.html',
      en: '/downloads/saas-cost-calculator-worksheet-2026.html',
    },
    fileName: {
      tr: 'figtures-saas-maliyet-hesaplayici-2026.html',
      en: 'figtures-saas-cost-calculator-2026.html',
    },
    title: {
      tr: 'SaaS Maliyet Hesaplayıcı (2026)',
      en: 'SaaS Cost Calculator Worksheet (2026)',
    },
    description: {
      tr: 'MVP, ölçekleme ve ekip senaryoları için bütçe aralığı çıkaran interaktif çalışma sayfası.',
      en: 'Interactive worksheet to estimate budget ranges for MVP, scale-up, and team scenarios.',
    },
    bullets: {
      tr: [
        'Faz bazlı maliyet kalemleri (discovery, MVP, v1.1)',
        'Ekip yapısı senaryoları (in-house vs. studio)',
        '12 aylık TCO ve runway kontrol listesi',
      ],
      en: [
        'Phase-based cost line items (discovery, MVP, v1.1)',
        'Team structure scenarios (in-house vs. studio)',
        '12-month TCO and runway checklist',
      ],
    },
  },
  'agency-selection-checklist': {
    id: 'agency-selection-checklist',
    downloadPath: {
      tr: '/downloads/yazilim-ajansi-secim-checklist-2026.html',
      en: '/downloads/software-agency-selection-checklist-2026.html',
    },
    fileName: {
      tr: 'figtures-yazilim-ajansi-secim-checklist-2026.html',
      en: 'figtures-software-agency-selection-checklist-2026.html',
    },
    title: {
      tr: '2026 Yazılım Ajansı Seçim Checklist’i',
      en: '2026 Software Agency Selection Checklist',
    },
    description: {
      tr: 'Teklifleri karşılaştırırken kullanabileceğiniz 32 maddelik puanlama tablosu.',
      en: 'A 32-point scoring sheet to compare proposals objectively.',
    },
    bullets: {
      tr: [
        'Teknik yetkinlik ve referans doğrulama soruları',
        'Teslimat modeli, SLA ve IP maddeleri',
        'Gizli maliyet ve risk bayrakları',
      ],
      en: [
        'Technical capability and reference verification prompts',
        'Delivery model, SLA, and IP clause checks',
        'Hidden cost and risk red flags',
      ],
    },
  },
  'mvp-scope-checklist': {
    id: 'mvp-scope-checklist',
    downloadPath: {
      tr: '/downloads/mvp-kapsam-checklist-2026.html',
      en: '/downloads/mvp-scope-checklist-2026.html',
    },
    fileName: {
      tr: 'figtures-mvp-kapsam-checklist-2026.html',
      en: 'figtures-mvp-scope-checklist-2026.html',
    },
    title: {
      tr: 'MVP Kapsam & Launch Checklist’i',
      en: 'MVP Scope & Launch Checklist',
    },
    description: {
      tr: 'Discovery öncesi kapsamı netleştirmek için kullanıcı hikâyesi ve launch hazırlık listesi.',
      en: 'User-story and launch-readiness list to clarify scope before discovery.',
    },
    bullets: {
      tr: [
        'Must-have / nice-to-have ayrımı şablonu',
        'Entegrasyon ve compliance kontrol noktaları',
        'Go-live öncesi 14 maddelik QA listesi',
      ],
      en: [
        'Must-have / nice-to-have separation template',
        'Integration and compliance checkpoints',
        '14-item pre-launch QA list',
      ],
    },
  },
};

const SLUG_TO_MAGNET: Record<string, string> = {
  'saas-development-cost-guide': 'saas-cost-worksheet',
  'saas-scaling-strategies': 'saas-cost-worksheet',
  'mvp-development-company-guide': 'mvp-scope-checklist',
  'mvp-development-guide': 'mvp-scope-checklist',
  'mobile-app-development-cost-guide': 'mvp-scope-checklist',
  'mobile-app-performance-optimization': 'mvp-scope-checklist',
  'ai-development-company-selection-guide': 'agency-selection-checklist',
  'custom-software-development-company-guide': 'agency-selection-checklist',
  'chatgpt-integration-business-guide': 'agency-selection-checklist',
  'ux-design-in-ai-products': 'agency-selection-checklist',
  'modern-fullstack-tooling': 'agency-selection-checklist',
  'data-security-and-compliance': 'agency-selection-checklist',
};

const DEFAULT_MAGNET_ID = 'agency-selection-checklist';

export function getBlogLeadMagnet(slug: string): BlogLeadMagnet {
  const magnetId = SLUG_TO_MAGNET[slug] ?? DEFAULT_MAGNET_ID;
  return MAGNETS[magnetId];
}

export function getBlogLeadMagnetDownloadUrl(magnet: BlogLeadMagnet, lang: 'tr' | 'en') {
  return magnet.downloadPath[lang];
}
